import React, { useState } from "react";
import {
  Badge,
  Icon,
  IconButton,
  makeStyles,
  Tooltip,
  withStyles,
} from "@material-ui/core";
import ContactSupportDialog from "./ContactSupportDialog";
import { useTranslation } from "react-i18next";
import { CONTACT_SUPPORT_ENABLED } from "../../../../util/Constants";

export const CONTACT_SUPPORT_ICON = "far fa-question-circle";

export const commonIcon = {
  width: "auto",
  height: "auto",
  padding: 2,
};

const useStyles = makeStyles((theme) => ({
  contactSupportBtn: {
    color: theme.palette.semaphore.orange,
  },
}));

// color: '#fff',
// bottom: '12px',
// right: '50px',
// padding: '4px',
// fontSize: '0.8rem',
// boxShadow: '0 0 5px rgba(0,0,0,0.2)',
// fontWeight: 'bold',
// borderRadius: '8px',
// backgroundColor: theme.palette.semaphore.orange

// bottom: '10px',
// color: '#fff',
// right: '25px',
// padding: '6px',
// fontSize: '0.8rem',
// boxShadow: '0 0 5px rgba(0,0,0,0.2)',
// fontWeight: 'bold',
// borderRadius: '8px',
// backgroundColor: theme.palette.semaphore.red,
// height: '13px'

const StyledBadge = withStyles((theme) => ({
  badge: {
    bottom: "10px",
    color: "#fff",
    right: "25px",
    padding: "6px",
    fontSize: "0.8rem",
    boxShadow: "0 0 5px rgba(0,0,0,0.2)",
    fontWeight: "bold",
    borderRadius: "8px",
    backgroundColor: theme.palette.semaphore.red,
    height: "13px",
  },
}))(Badge);

export default function ContactSupportButton() {
  const classes = useStyles();
  const { t } = useTranslation();
  const [openDialog, setOpenDialog] = useState(false);

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  if (!CONTACT_SUPPORT_ENABLED) {
    return null;
  }

  return (
    <>
      <StyledBadge
        badgeContent={"BETA"}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        showZero={false}
      >
        <Tooltip title={t("SUPPORT.BTN_TOOLTIP")}>
          <IconButton
            className={classes.contactSupportBtn}
            onClick={handleOpenDialog}
          >
            <Icon
              className={CONTACT_SUPPORT_ICON}
              style={{ ...commonIcon, fontSize: "1.5rem" }}
            />
          </IconButton>
        </Tooltip>
      </StyledBadge>
      <ContactSupportDialog open={openDialog} onClose={handleCloseDialog} />
    </>
  );
}
